var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Procedimentos","type":"fieldset"}},[_c('ProcedimentoPrimario',{ref:"ProcedimentoPrincipal",attrs:{"data":_vm.data}}),_c('ProcedimentoSecundario',{ref:"ProcedimentoSecundario",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }